export default class SteelBarFormModel{
    contractNO: string | undefined
    customerRefNO: string | undefined
    customer: string | undefined
    project: string | undefined
    dateDelivered: string | undefined
    supplier: string | undefined
    testingAccordance: string | undefined
    isOtherTestingAccordance: boolean | undefined
    testingAccordanceOther: string | undefined
    expressOrNot: boolean | undefined
    expressThirtyOrFifty: string | undefined
    steelLaboratoryFeedback: string | undefined
    chemistryLaboratoryFeedback: string | undefined
    conformity: string | undefined
    contactPerson: string | undefined
    telNO: number | undefined
    faxNO: number | undefined
    email: string | undefined
    sendTo: string | undefined
    billTo: string | undefined
    remark: string | undefined

    SteelBarFormMapping = (steelBarRecord : {[key: string]: any} | undefined) =>{
        console.log(steelBarRecord);
        this.contractNO = steelBarRecord![0]["contracT_NO"];
        this.customerRefNO = steelBarRecord![0]["customer_REF_NO"];
        this.customer = steelBarRecord![0]["customer"];
        this.project = steelBarRecord![0]["project"];
        this.dateDelivered = steelBarRecord![0]["datE_DELIVERED"];
        this.supplier = steelBarRecord![0]["supplier"];
        this.testingAccordance = steelBarRecord![0]["testinG_ACCORDANCE"];
        this.isOtherTestingAccordance = steelBarRecord![0]["iS_OTHER_TESTING_ACCORDANCE"];
        this.expressOrNot = steelBarRecord![0]["expresS_OR_NOT"];
        this.expressThirtyOrFifty = steelBarRecord![0]["expresS_THIRTY_OR_FIFTY"];
        this.steelLaboratoryFeedback = steelBarRecord![0]["steeL_LABORATORY_FEEDBACK"];
        this.chemistryLaboratoryFeedback = steelBarRecord![0]["chemistrY_LABORATORY_FEEDBACK"];
        this.conformity = steelBarRecord![0]["conformity"];
        this.contactPerson = steelBarRecord![0]["contacT_PERSON"];
        this.telNO = steelBarRecord![0]["teL_NO"];
        this.faxNO = steelBarRecord![0]["faX_NO"];
        this.email = steelBarRecord![0]["email"];
        this.sendTo = steelBarRecord![0]["send_TO"];
        this.billTo = steelBarRecord![0]["bill_TO"];
        this.remark = steelBarRecord![0]["remark"];
    }
}